export interface JobPaginationOptions {
    pageNumber: number;
    pageSize: number;
}
